import styled from 'styled-components'

export const ContainerTicket = styled.div`
    height: 100%;
`

export const Background = styled.img`
    width: 100vw;
    height: 680px;
    object-fit: cover;
    position: absolute;
    z-index: -1;
    @media(max-width: 425px){
        height: 867px;
    }
    @media(max-width: 375px){
        height: 955px;
    }
    @media(max-width: 320px ) {
        height: 1022px;
    }
`

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    color: var(--text-body);
    align-items: center;
    padding-top: 5rem;
    padding-bottom: 5rem;
    h2 {
        padding-bottom: 2.5rem;
        font-family: 'Moby';
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 55px;
        text-align: center;
    }
    p {
        max-width: 1270px;
        box-sizing: border-box;
        max-width: 90vw;
        margin: 0 auto;
        text-align: center;
        font-weight: 600;
        line-height: 32px;
        font-size: 18px;
    }
    h1 {
        text-align: center;
        padding-top: 2.5rem;
        padding-bottom: 1rem;
        font-family: 'Moby';
        font-style: normal;
        font-weight: 400;
        font-size: 50px;
        line-height: 60px;
    }
    .opction {
        font-family: 'Moby';
        box-sizing: border-box;
        max-width: 90vw;
        margin: 0 auto;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 32px;
        padding-bottom: 5rem;
        text-align: center;
    }
    @media(max-width: 1024px){
        p {
            margin-left: 2rem;
            margin-right: 2rem;
        }
        h1 {
            padding-bottom: 2.5rem;
        }
    }
    @media(max-width: 768px) {
        .opction {
            margin-left: 1rem;
            margin-right: 1rem;
        }
    }
    @media(max-width: 588px) {
        h1 {
            font-size: 70px;
        }
    }
    @media(max-width: 514px) {
        h1 {
            font-size: 60px;
        }
        p {
            margin-left: 2rem;
            margin-right: 2rem;
        }
    }
    @media(max-width: 441px) {
        h1 {
            font-size: 49px;
        }
    }
    @media(max-width: 320px) {
        
    padding-bottom: 3rem;
        h1 {
            font-size: 34px;
        }
    }
`

export const Button = styled.div`
    width: 460px;
    height: 56px;
    background-color: var(--background-season-2);
    border-radius: 40px;
    a {
        color: var(--text-title);
        font-family: 'Graphik';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 51px;
        display: flex;
        justify-content: center;
    }
    
    @media(max-width: 441px) {
        width: 348px;
        a {
            font-size: 19px;
        }
    }

    @media(max-width: 320px) {
        width: 290px;
        a {
            font-size: 17px;
        }
    }


`